/* eslint-disable */
import { Configuration } from '@/openapi/order';
import EnvRepository from '@/repository/EnvRepository';

export default class OrderApiConfig {
  static newInstance(): Configuration {
    const basePath = EnvRepository.getEnv().VUE_APP_API_BASE_PATH_ORDER;

    return new Configuration({
      basePath,
      // apiKey: "",
      // username: "",
      // password: "",
      // accessToken: "",
      credentials: 'include',
    });
  }
}
